<template>
  <div>
    <Title class="center-title">离职申请</Title>
    <template>
      <div class="panel">
        <div class="label">申请人</div>
        <div class="value1">{{ extra.applicant || '—' }}</div>
        <div class="label">申请部门</div>
        <div class="value2">{{ extra.applyDept || '—' }}</div>

        <div class="label">岗位或职务</div>
        <div class="value1">{{ extra.position || '—' }}</div>
        <div class="label">参加工作时间</div>
        <div class="value2">{{ extra.workStartDate | dateFormat }}</div>

        <div class="label">合同开始时间</div>
        <div class="value1">{{ extra.contractStartDate | dateFormat }}</div>
        <div class="label">合同结束时间</div>
        <div class="value2">{{ extra.contractEndDate | dateFormat }}</div>

        <div class="label">入职日期</div>
        <div class="value1">{{ extra.entryDate | dateFormat }}</div>
        <div class="label">离职日期</div>
        <div class="value2">{{ extra.leaveDate | dateFormat }}</div>

        <div class="label">离职原因</div>
        <div class="value3">{{ extra.leaveReason || '' }}</div>

        <template v-if="['dept_leader', 'office_hr', 'hr_dept', 'review_submit'].includes(taskDefKey)">
          <div class="label">附件</div>
          <div class="value3">
            <template v-if="fileList.length > 0">
              <div v-for="item in fileList" :key="item.id">
                <a :href="item.completePath || item.url" target="_blank">{{ item.name || item.fileName || '下载附件' }}</a>
              </div>
            </template>
            <template v-else>—</template>
          </div>
        </template>
      </div>
    </template>
    <Padding/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "../../Title";
import moment from "moment";

export default {
  components: { Title },
  filters: {
    dateFormat(val) {
      if (!val) return '—';
      return moment(val).format('YYYY-MM-DD');
    },
  },
  computed: {
    ...mapState("approval", ["detail"]),
    taskDefKey() {
      return this.detail?.taskDefinitionKey || "";
    },
    extra() {
      return (this.detail && this.detail.extra) ? this.detail.extra : {};
    },
    fileList() {
      const list = this.extra.attachmentList;
      if (Array.isArray(list)) {
        return list.filter(item => item && item.id);
      }
      return [];
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .center-title {
  font-size: 24px;
  left: 0;
  text-align: center;
  margin-top: -65px;
  margin-bottom: 30px;
  margin-left: 150px;

  &::before {
    display: none;
  }
}

.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  & > div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
}
</style>
